import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div data-test-field-type=\"note\"></div>\n",{ moduleName: "garaje/pods/components/plugin-config-field/note/template.hbs" })